<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <div
      class="white-container">
      <TemplateView
        :fields="fields"
      />
    </div>
  </div>
</template>

<script>
  import fields from './templateCreationFields.js';
  import TemplateView from './TemplateView';

  export default {
    name: 'TemplateCreation',
    components: {
      TemplateView
    },
    data () {
      return {
        fields: fields
      }
    },
  }
</script>